import { CoreBaseService } from "@core/services/Base.service";

// Reference model
import { ClientModel } from "@models/ClientModel";

class ClientsService extends CoreBaseService {
  constructor() {
    super(ClientModel);
  }
}

const inst = new ClientsService();

export default inst;
